import React from 'react';
import { JsonLd } from "react-schemaorg";
export default function SiteNavigationElementSchema(name, url) {
    return (React.createElement(JsonLd, { item: {
            "@context": "https://schema.org",
            '@type': 'SiteNavigationElement',
            name: name ? name : "",
            url: url ? url : ""
        } }));
}
